import React, { useEffect, useMemo, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { resolveOnboardingRecord } from "../../features/onboarding/service";

export default function OnboardingGate({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user, loading } = useAuth();
  const [checking, setChecking] = useState(true);
  const [completed, setCompleted] = useState(false);

  const userKey = useMemo(
    () => user?.uid || user?.email || "anonymous",
    [user?.uid, user?.email]
  );

  useEffect(() => {
    let active = true;
    if (!user) {
      setChecking(false);
      return;
    }

    resolveOnboardingRecord(userKey)
      .then((record) => {
        if (!active) return;
        setCompleted(record.completed);
      })
      .finally(() => {
        if (active) setChecking(false);
      });

    return () => {
      active = false;
    };
  }, [user, userKey]);

  if (loading || checking) {
    return (
      <div className="grid min-h-screen place-items-center bg-[#F8FAFC] px-4">
        <div className="rounded-3xl border border-[#E5E7EB] bg-white px-6 py-5 text-center shadow-sm">
          <div className="text-lg font-semibold text-[#0F172A]">
            Preparing your workspace
          </div>
          <div className="mt-1 text-sm text-[#6B7280]">
            We’re checking whether onboarding is already complete.
          </div>
        </div>
      </div>
    );
  }

  // TEMP: static onboarding testing mode
  // if (!completed) {
  //   return <Navigate to="/onboarding" replace />;
  // }

  return <>{children}</>;
}
